import { env } from '~/env';
import { history } from './store';
import { routeStorage } from '../features/login/storage';
import { reportErrorToSentry } from './sentry';

const saveCurrentRoute = () => {
    const initialRoute = [window.location.hash, window.location.search].join('').replace(/^#\/?/u, '');
    routeStorage.saveRoute(initialRoute);
};

export const attemptInitialSignIn = async userManager => {
    const isFreshRedirect = window.location.href.includes('redirected');

    try {
        await userManager.clearStaleState();
        const user = await userManager.signinSilent();
        const initialRoute = routeStorage.getRoute();
        if (initialRoute && isFreshRedirect) {
            history.replace(`/${initialRoute}`);
        }
        routeStorage.discardRoute();
        return user;
    } catch (error) {
        console.log('sign in error ->> ', error);
        const previousUser = await userManager.getUser();
        reportErrorToSentry(error, {
            tags: { module: 'login', authFlow: isFreshRedirect ? 'post-redirect' : 'initial' },
            user: { email: previousUser?.profile?.email, id: previousUser?.profile?.sub },
        });
        if (env.runtimeConfig.login.preventRedirect) {
            // eslint-disable-next-line no-console
            console.warn('[feature/login] redirect prevented due to config. Error was', error);
        } else if (isFreshRedirect) {
            routeStorage.discardRoute();
        } else {
            saveCurrentRoute();
            const errorMsg = error?.message || '';
            if (errorMsg.includes('AADSTS16000')) {
                userManager.signinRedirect({ prompt: 'login' });
            } else {
                userManager.signinRedirect({ prompt: 'select_account' });
            }
        }

        throw new Error('Need to sign in');
    }
};
